<!--
  Footer del portal. El contenido lo pide AZUL (políticas, identidad del
  comercio, contacto, marcas aceptadas, sellos 3-D Secure y moneda), así que no
  hay nada de adorno acá. El orden va de lo más accionable a lo menos: enlaces →
  identidad → pagos → copyright.
-->
<template>
  <div class="app-footer">
    <!-- 1. Enlaces legales: lo único clickeable, va primero -->
    <div
      align="center"
      class="footer-links mb-1"
    >
      <b-link
        :to="{ name: 'legal-services' }"
        class="small"
      >
        Servicios
      </b-link>
      <b-link
        :to="{ name: 'legal-terms' }"
        class="small"
      >
        Términos y Condiciones
      </b-link>
      <b-link
        :to="{ name: 'legal-privacy' }"
        class="small"
      >
        Privacidad
      </b-link>
      <b-link
        :to="{ name: 'legal-security' }"
        class="small"
      >
        Seguridad
      </b-link>
      <b-link
        :to="{ name: 'legal-refunds' }"
        class="small"
      >
        Devoluciones
      </b-link>
      <b-link
        :to="{ name: 'legal-delivery' }"
        class="small"
      >
        Entrega
      </b-link>
      <b-link
        :to="{ name: 'legal-contact' }"
        class="small"
      >
        Contacto
      </b-link>
    </div>

    <!-- 2. Identidad del comercio: razón social, no el nombre comercial, que es
         lo que tiene que quedar visible para el cumplimiento -->
    <div
      align="center"
      class="footer-business mb-1"
    >
      <div>
        {{ business.legalName }} · {{ business.address }} ·
        {{ business.country }}
      </div>
      <div>
        Tel:
        <a :href="`tel:${business.phone}`">{{ business.phone }}</a> ·
        <a :href="`mailto:${business.email}`">{{ business.email }}</a>
      </div>
    </div>

    <!-- 3. Pagos. Los sellos van en DOS grupos: Visa Secure y Mastercard ID
         Check no son formas de pago que se aceptan, son protocolos de
         autenticación del tarjetahabiente. Bajo un solo "Aceptamos" se leían
         como si fueran cinco maneras de pagar. -->
    <div class="footer-payments mb-1">
      <div class="footer-marks-group">
        <span class="footer-marks-label">Aceptamos</span>
        <div class="footer-marks">
          <b-img
            :src="brands.visa"
            alt="Visa"
            height="30"
          />
          <b-img
            :src="brands.mastercard"
            alt="Mastercard"
            height="30"
          />
          <b-img
            :src="imgPayPal"
            alt="PayPal"
            height="26"
          />
        </div>
      </div>

      <div class="footer-marks-group">
        <span class="footer-marks-label">Compra protegida por</span>
        <div class="footer-marks">
          <b-img
            :src="brands.visaSecure"
            alt="Visa Secure"
            height="30"
          />
          <b-img
            :src="brands.mcIdCheck"
            alt="Mastercard ID Check"
            height="30"
          />
        </div>
      </div>
    </div>

    <!-- 4. Copyright: la línea menos importante, y va con el cuerpo más chico -->
    <p class="footer-copyright text-center mb-0">
      © {{ new Date().getFullYear() }}
      <b-link
        :href="business.website"
        target="_blank"
      >{{
        business.legalName
      }}</b-link>
      · Todos los derechos reservados
    </p>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BImg, BLink } from "bootstrap-vue"
import business from "@/business"

export default {
  components: {
    BLink,
    BImg,
  },
  data() {
    return {
      business,
      imgPayPal: require("@/assets/images/logo/paypal.png"),
      brands: {
        visa: require("@/assets/images/brands/visa.jpg"),
        mastercard: require("@/assets/images/brands/mastercard.jpg"),
        visaSecure: require("@/assets/images/brands/visa-secure.png"),
        mcIdCheck: require("@/assets/images/brands/mastercard-idcheck.png"),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.footer-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.25rem 1rem;
}

.footer-business {
    font-size: 0.875rem;
    color: var(--tm-text-secondary);
    line-height: 1.6;
}

.footer-payments {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.75rem 1.5rem;
}

.footer-marks-group {
    display: flex;
    align-items: center;
    gap: 0.625rem;
}

// Las dos tiras de sellos se parecen entre sí, así que sólo con el espacio se
// leen como una sola fila larga. El divisor hace explícito que son dos grupos.
@media (min-width: 576px) {
    .footer-marks-group + .footer-marks-group {
        padding-left: 1.5rem;
        border-left: 1px solid var(--tm-border);
    }
}

.footer-marks-label {
    font-size: 0.75rem;
    color: var(--tm-text-muted);
    white-space: nowrap;
}

.footer-marks {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

.footer-currency {
    font-size: 0.75rem;
    color: var(--tm-text-muted);
}

// El copyright iba en 1rem contra los 0.875 de los datos del comercio: la línea
// menos importante era la más grande de todo el footer.
.footer-copyright {
    font-size: 0.75rem;
    color: var(--tm-text-muted);
}

@media (max-width: 575.98px) {
    .footer-payments {
        flex-direction: column;
        gap: 0.75rem;
    }
}
</style>
